export const blogCategories = ["All", "Strategy", "Growth", "Influencer", "Content", "Social"];

export const blogs = [
  {
    id: 1,
    title: "Digital Marketing Strategies That Win in 2026",
    category: "Strategy",
    date: "2026-02-20",
    excerpt:
      "A modern playbook for brands that want measurable ROI, not vanity metrics. We break down the strategy stack that performs.",
    readTime: "6 min read",
    featured: true
  },
  {
    id: 2,
    title: "Content Marketing That Feels Premium and Converts",
    category: "Content",
    date: "2026-01-18",
    excerpt:
      "Your content should build authority and pipeline. Here's how to craft a system that drives both.",
    readTime: "5 min read",
    featured: false
  },
  {
    id: 3,
    title: "Influencer Marketing Without the Guesswork",
    category: "Influencer",
    date: "2025-12-12",
    excerpt:
      "We outline a framework to pick the right creators, structure deals, and track conversions.",
    readTime: "4 min read",
    featured: false
  },
  {
    id: 4,
    title: "Brand Growth Through Community and Social Proof",
    category: "Growth",
    date: "2025-11-02",
    excerpt:
      "Trust scales. Learn how to build community and credibility that increases conversion rates.",
    readTime: "7 min read",
    featured: false
  },
  {
    id: 5,
    title: "Social Media Growth: The Metrics That Matter",
    category: "Social",
    date: "2025-10-10",
    excerpt:
      "Ditch vanity metrics. Focus on the KPI stack that tells you what's actually working.",
    readTime: "5 min read",
    featured: false
  }
];